module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-slider'],
    style: (_vm._px2rem(_vm.disabledStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-touchstart": "",
      "data-evt-horizontalpan": "",
      "data-evt-touchend": ""
    },
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.onTouchStart($event)
      },
      "horizontalpan": _vm.onTouchMove,
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.onTouchEnd($event)
      }
    }
  }, [_c('div', {
    key: _vm._isColmo + 'slider',
    ref: "track",
    staticClass: "dof-slider-track weex-ct weex-div",
    style: (_vm._px2rem(_vm.trackStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.isGradientBar) ? _c('div', {
    staticClass: "dof-slider-thin-bar weex-ct weex-div",
    style: (_vm._px2rem(_vm.thinBarStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm._gradientBarConfig.mid) ? _c('div', {
    staticClass: "dof-slider-thin-bar-left weex-ct weex-div",
    style: ({
      backgroundImage: ("linear-gradient(to right, " + (_vm._gradientBarConfig.start) + ", " + (_vm._gradientBarConfig.mid) + ")"),
      width: _vm._px2rem(_vm.midWidth + _vm._buttonSize / 2 + 1 + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (_vm._gradientBarConfig.mid) ? _c('div', {
    staticClass: "dof-slider-thin-bar-right weex-ct weex-div",
    style: ({
      backgroundImage: ("linear-gradient(to right, " + (_vm._gradientBarConfig.mid) + ", " + (_vm._gradientBarConfig.end) + ")"),
      width: _vm._px2rem(_vm.midWidth + _vm._buttonSize / 2 - 1 + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm._gradientBarConfig.mid) ? _c('div', {
    staticClass: "dof-slider-thin-bar-left weex-ct weex-div",
    style: ({
      backgroundImage: ("linear-gradient(to right, " + (_vm._gradientBarConfig.start) + ", " + (_vm._gradientBarConfig.end) + ")"),
      right: _vm._px2rem(1 + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isGradientBar) ? _c('div', {
    staticClass: " weex-ct weex-div",
    style: (_vm._px2rem(_vm.lineStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "bar",
    staticClass: " weex-ct weex-div",
    class: ['dof-slider-bar'],
    style: (_vm._px2rem(_vm.barStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [(!_vm.isGradientBar) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: [_vm.barColor || _vm.isGradientBar ? '' : ("dof-slider-bar--" + (this.theme))],
    style: (_vm._px2rem(_vm.smallBarStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.buttonStyle), function(itemStyle, i) {
    return _c('div', {
      key: i + _vm.disabled,
      staticClass: " weex-ct weex-div",
      class: ['dof-slider-button', _vm.isGradientBar ? 'button-scale' : '', _vm._isColmo && _vm.disabled ? 'hideButton' : ''],
      style: (_vm._px2rem(itemStyle, 75)),
      attrs: {
        "weex-type": "div"
      }
    })
  })], 2)]), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "dof-slider-scales weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_vm._t("default", null, {})], 2) : _vm._e(), _vm._v(" "), (_vm.isGradientBar && _vm.disabled) ? _c('div', {
    staticClass: "dof-slider-disabled-mask weex-ct weex-div",
    attrs: {
      "weex-type": "div",
      "data-evt-touchstart": ""
    },
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.maskTouchStart($event)
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-db384bc8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db384bc8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-slider/index.vue
// module id = 661
// module chunks = 0 1